import React from 'react';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMUserResource from 'resources/SMUserResource';
import SMMasterResource from 'resources/SMMasterResource';

class SMUSettingEditBasicFragmentView extends SMUSettingEditBaseFragment {
  
  constructor(props) {
    super(props);

    this.formRequest = null;
    this.state = {
      user: this.props.user,
      contact: this.props.user.contact ? this.props.user.contact.attributes : {},
      isCurrent : this.isCurrent(this.props),
      timeZones: [],
      errors: this.props.errors,
      profileImage: this.props.user.profile_image,
    };
  }
  
  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000020'));
    
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
    
    SMMasterResource.getTimeZones((timeZones, error, xhr)=>{
      this.setState({ timeZones: timeZones });
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  formDidSubmit(e){
    e.preventDefault();
    
    let formData = new FormData(e.currentTarget);
    if (this.formRequest) this.formRequest.abort();
    this.formRequest = SMUserResource.updateUser(formData, {}, (user, error, xhr)=>{
      this.formRequest = null;
      if (error) {
        this.setState({errors: xhr.responseJSON.errors});
        return;
      } else if (xhr.status == 200) {
        this.setState({
          user: user,
          errors: []
        });
        this.props.delegate.showSuccessMessage();        
      }
    });
  }

  fileDidUpload(e) {    
    if (!e.currentTarget.files.length) return;
    let file = e.currentTarget.files[0],
        fileReader = new FileReader();
    let $fileInput = $(this.refs.profile_image);
    fileReader.onload = (e)=>{
      this.setState({profileImage: e.target.result});
    };
    fileReader.readAsDataURL(file);
  }
  
  renderProfileImage(){
    if (this.state.profileImage) {
      let style = {backgroundImage:"url("+this.state.profileImage+")"};
      
      return(
        <span className="settings-img__change-img" style={style}>
          <label htmlFor="profile_image" className="button-gray settings-img">
            <span className="icon-ll"><i className="fa fa-camera"></i></span><br />{I18n.t('dashboard.label_000055')}
          </label>
        </span>
      );
    } else {
      return(
        <label htmlFor="profile_image" className="button-gray settings-img">
          <span className="icon-ll"><i className="fa fa-camera"></i></span><br />{I18n.t('dashboard.label_000117')}
        </label>
      );
    }
  }
  
  render() {
    let timeZones = [];
    
    for (let i=0; i < this.state.timeZones.length; i++) {
      timeZones.push({value: this.state.timeZones[i].name, 
                      label: this.state.timeZones[i].name_text});
    }      
    
    return(
      <div style={this.fragmentStyle()}>
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <SMFormFieldTitle title={I18n.t('dashboard.label_000168')} isRequired={true} />
          <SMFormTextFieldWithError 
            name="name" 
            value={this.state.user.name} 
            errorText={SMFormatHelper.errorText('User', 'name', this.state.errors)}
            placeholderText={I18n.t('dashboard.label_000038')} 
            options={{className:'w400'}}
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000095')} subTitle={I18n.t('dashboard.label_000169')} isRequired={true} />
          <SMFormTextFieldWithError 
            name="email" 
            value={this.state.user.email} 
            errorText={SMFormatHelper.errorText('User', 'email', this.state.errors)}
            placeholderText={I18n.t('dashboard.label_000068')} 
            options={{className:'w400'}}
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000059')} isRequired={true} />
          <div className="form-box">
            <input ref="profile_image" onChange={this.fileDidUpload.bind(this)} type="file" name="profile_image" id="profile_image" hidden />
            {this.renderProfileImage()}
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000170')} subTitle={I18n.t('dashboard.text_000031')} isRequired={false} />
          <SMFormTextAreaWithError 
            name="profile" 
            value={this.state.user.profile} 
            errorText={SMFormatHelper.errorText('User', 'profile', this.state.errors)}
            placeholderText={I18n.t('dashboard.text_000032')} 
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000062')} subTitle={I18n.t('dashboard.text_000033')} isRequired={true} />
          <div className="form-box">
            https://spacemarket.com/users/
            <SMFormTextField
              name="username" 
              value={this.state.user.username} 
              errorText={SMFormatHelper.errorText('User', 'username', this.state.errors)}
              options={{className:'w400'}}
              delegate={this}
            />
            <SMFormValidationMessage name="username" errorText={SMFormatHelper.errorText("User", "username", this.state.errors)} />
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000171')} isRequired={true} />
          <div className="form-box">
            <span className="form-select__inner">
              <label className="form-select">
                <SMFormSelectBox name='time_zone' items={timeZones} selectedValue={this.state.user.time_zone} delegate={this} options={{className:'w400'}} />
              </label>
            </span>
          </div>

          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}

export default SMUSettingEditBasicFragmentView;




// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditBasicFragmentView.jsx